import { Card } from "@mui/material";
import { Divider } from "@monolith-forensics/monolith-ui";
import { useState } from "react";
import DropDownSelector from "../../../../components/DropDownSelector";
import Loader from "../../../../components/Loader";
import DefaultPieChart from "../DefaultPieChart";
import DefaultTextChart from "../DefaultTextChart";

const views = [
  {
    text: "Charts",
    value: 0,
  },
  {
    text: "Text",
    value: 1,
  },
];

export const TimeEntryComposition = ({ metrics }) => {
  const [currentView, setCurrentView] = useState(0);

  return (
    <Card
      style={{
        padding: "20px",
        marginBottom: "20px",
        height: "350px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "larger",
            }}
          >
            Time Entry Composition (hrs)
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ marginRight: "10px" }}>
              <DropDownSelector
                items={views}
                useSelectMode={true}
                selectedItem={currentView}
                displayExpr="text"
                variant="contained"
                onSelect={(item) => {
                  setCurrentView(item.value);
                }}
              />
            </div>
          </div>
        </div>
        <Divider style={{ margin: "16px 0" }} />

        {!metrics && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loader />
          </div>
        )}
        {metrics && currentView === 0 && (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <DefaultPieChart
              data={metrics.categories}
              title="Categories"
              valueExpr="name"
            />
            <DefaultPieChart
              data={metrics.invoiced}
              title="Invoiced"
              valueExpr="name"
            />
            <DefaultPieChart
              data={metrics.users}
              title="Time Recorded by User"
              valueExpr="name"
            />
            <DefaultPieChart
              data={metrics.org_clients}
              title="Time Recorded by Client Organization"
              valueExpr="name"
            />
          </div>
        )}
        {metrics && currentView === 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              userSelect: "text",
            }}
          >
            <DefaultTextChart
              data={metrics.categories}
              title="Categories"
              valueExpr="name"
            />
            <DefaultTextChart
              data={metrics.invoiced}
              title="Invoiced"
              valueExpr="name"
            />
            <DefaultTextChart
              data={metrics.users}
              title="Time Recorded by User"
              valueExpr="name"
            />
            <DefaultTextChart
              data={metrics.org_clients}
              title="Time Recorded by Client Organization"
              valueExpr="name"
            />
          </div>
        )}
      </div>
    </Card>
  );
};
